import { createSelector } from 'reselect';

export const smartEngageStateSelector = state => state.smartEngage;

// export const goTribeBannerSelector = createSelector(smartEngageStateSelector, item => {
//   const retVal = {
//     isLoading: true,
//     dataList: [],
//   };

//   if (item && item.data && item.data.slots) {
//     retVal.isLoading = item.isLoading;
//     const {slots} = item.data;
//     const {gotribe_flight_srp = []} = slots;
//     retVal.dataList = [...gotribe_flight_srp];
//   }

//   return retVal;
// });

// export const srpOfferBannersSelector = createSelector(smartEngageStateSelector, item => {
//   const retVal = {
//     isLoading: true,
//     dataList: [],
//   };

//   if (item && item.data && item.data.slots) {
//     retVal.isLoading = item.isLoading;
//     const {slots} = item.data;
//     let offerSlots = Object.keys(slots).filter(v => v.startsWith('flight_test_slot'));
//     offerSlots.map((slotKey) => {
//       retVal.dataList.push(slots[slotKey]);
//     })
//   }

//   return retVal;
// });

export const smartEngageBannerSelector = createSelector(smartEngageStateSelector, item => {
  const retVal = {
    isLoading: true,
    dataList: []
  };

  if (item && item.data && item.data.slots) {
    retVal.isLoading = item.isLoading;
    const { slots } = item.data;
    const { gotribe_flight_srp = [] } = slots;
    const { gotribe_flight_srp_dweb = [] } = slots;
    const { flight_slot_sem = [] } = slots;

    let offerSlotKeys = Object.keys(slots).filter(v => v.startsWith('flight_test_slot'));

    if (flight_slot_sem && flight_slot_sem.length) {
      retVal.dataList.push({
        originalIndex: 'offerBanner',
        data: flight_slot_sem
      });
    }
    if (offerSlotKeys.length) {
      retVal.dataList.push({
        originalIndex: 'offerBanner',
        data: slots[offerSlotKeys[0]]
      });
    }
    if (gotribe_flight_srp && gotribe_flight_srp.length) {
      retVal.dataList.push({
        originalIndex: 'goTribeBanner',
        data: gotribe_flight_srp
      });
    }
    if (gotribe_flight_srp_dweb && gotribe_flight_srp_dweb.length) {
      retVal.dataList.push({
        originalIndex: 'goTribeBanner',
        data: gotribe_flight_srp_dweb
      });
    }
    for (let i = 1; i < offerSlotKeys.length; i++) {
      retVal.dataList.push({
        originalIndex: 'offerBanner',
        data: slots[offerSlotKeys[i]]
      });
    }
  }

  return retVal;
});
